import React, {useEffect, useState} from "react";
import VectorLayer from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";
import {Geometry} from "ol/geom";
import OpenLayerMapComponent from "./OpenLayerMapComponent"; 
import {farmBoundaryStyle,landBoundaryStyle, makeVectorLayer,readGeoJsonFeature,readGeoJsonFeatureCollection} from "../helpers/map"; 
import FarmController from "../generated/controllers/farmController";

const TestTiffs: React.FC = () => {
    const [mapLayers, setMapLayers] = useState<VectorLayer<VectorSource<Geometry>>[]>([])
    const [mapLayersNew, setMapLayersNew] = useState<VectorLayer<VectorSource<Geometry>>[]>([])
    const farmId = 19504;
    
    useEffect(() => {
        FarmController.geoJson(farmId).then((response) => {
            let farmBoundary = makeVectorLayer(readGeoJsonFeatureCollection(response.farm), farmBoundaryStyle)
            let landBoundaries = makeVectorLayer(response.lands.filter(l => l.length > 0).map(readGeoJsonFeature), landBoundaryStyle)
    
            setMapLayers([farmBoundary, landBoundaries])
            setMapLayersNew([farmBoundary, landBoundaries])
        })
    }, []);

    return (
        mapLayers.length === 0 || mapLayersNew.length === 0 ? (
            <div>Nothing. Check home controller BuildCog</div>
        ) : (
            <div className="fixed top-0 left-0 bg-white flex w-screen h-screen">
                <div className="w-1/2 p-4 text-center">
                    <span className="text-3xl">All data.</span>
                    <OpenLayerMapComponent
                        layers={mapLayers}
                        tiffUrl={`/api/protected_tiffs/test_normal_${farmId}.2E-05.cog.tiff`}
                    />
                </div>
                <div className="w-1/2 p-4 text-center">
                    <span className="text-3xl">Filtered</span>
                    <OpenLayerMapComponent
                        layers={mapLayersNew}
                        tiffUrl={`/api/protected_tiffs/test_new_${farmId}.tiff`}
                    />
                </div>
            </div>
        )
    );
}

export default TestTiffs;
